/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Notice from 'components/notice';
import { getCurrentRental } from 'state/current-rental/selectors';
import { getCurrentRetailerRental } from 'state/current-retailer-rental/selectors';

const ScheduledChangesNotice = ({ currentRetailerRental, currentRental }) => {
    // Retailer-rental (AU/NZ) takes precedence when present, matching the
    // same resolution used for the subscription details card — a customer
    // can have either, and this notice should reflect whichever is shown.
    const hasRetailerRental = currentRetailerRental && currentRetailerRental.length > 0;
    const rentals = hasRetailerRental ? currentRetailerRental : currentRental;
    const hasScheduledChanges = (rentals || []).some((rental) => rental.subscription.has_scheduled_changes);

    if (!hasScheduledChanges) {
        return null;
    }

    return (
        <Notice
            text='You have pending changes to your rental subscription.'
            subText='These will take effect at the end of the current payment period.'
            showDismiss={false}
        />
    );
};

export default connect((state) => ({
    currentRetailerRental: getCurrentRetailerRental(state),
    currentRental: getCurrentRental(state),
}))(ScheduledChangesNotice);
